export class LeadsSettingsHelper {
  static updateLeadsListSettings(leadsListId) {
    fetch("/leads/settings", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        user: { current_leads_list_id: leadsListId },
      }),
      credentials: "same-origin",
    })
  }
}
